import { useRef, useEffect } from 'react'
import videojs from 'video.js'
import 'video.js/dist/video-js.css'
import { proxySourcePath } from '@/utils/common'

/**
 * options: https://videojs.moyutime.cn/2022/02/14/course/%E9%85%8D%E7%BD%AE/
 */
export const VideoJS = ({ options }) => {
  const videoRef = useRef(null)
  const playerRef = useRef(null)

  useEffect(() => {
    if (!playerRef.current) {
      const videoElement = document.createElement('video-js')

      videoElement.classList.add('vjs-big-play-centered')
      videoRef.current.appendChild(videoElement)
      options.sources = options.sources.map(item => ({
        ...item,
        src: proxySourcePath(item.src),
      }))
      const player = (playerRef.current = videojs(videoElement, options, () => {
        videojs.log('player is ready')
        playerRef.current = player

        player.on('waiting', () => {
          videojs.log('player is waiting')
        })

        player.on('dispose', () => {
          videojs.log('player will dispose')
        })
        // onReady && onReady(player)
      }))
    } else {
      const player = playerRef.current

      player.autoplay(options.autoplay)
      player.src(
        options.sources.map(item => ({
          ...item,
          src: proxySourcePath(item.src),
        })),
      )
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [options.src])

  useEffect(() => {
    const player = playerRef.current

    return () => {
      if (player && !player.isDisposed()) {
        player.dispose()
        playerRef.current = null
      }
    }
  }, [playerRef])

  return (
    // <div data-vjs-player>
    <div ref={videoRef} data-vjs-player />
    // </div>
  )
}

export default VideoJS
